import { Outlet, createFileRoute } from "@tanstack/react-router";

import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.PERFORMANCE)({
    component: RouteComponent,
    staticData: {
        config: {
            breadcrumb: {
                title: "performance",
                to: APP_ROUTES_TO.PERFORMANCE_KPIS,
            },
            title: "performance",
        },
    },
});

function RouteComponent() {
    return <Outlet />;
}
